(function () {
  var roots = document.querySelectorAll('[data-dt-pdp-ab]');
  if (!roots.length) return;

  function formatMoney(cents, fallbackFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, fallbackFormat);
    }

    return 'Rs. ' + (Number(cents || 0) / 100).toLocaleString('en-IN', {
      maximumFractionDigits: 0
    });
  }

  roots.forEach(function (root) {
    var variants = [];
    try {
      variants = JSON.parse(root.dataset.variants || '[]');
    } catch (error) {
      variants = [];
    }

    var moneyFormat = root.dataset.moneyFormat || '';
    var selectedOptions = [];
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var productForm = root.querySelector('[data-main-product-form]') || root.querySelector('.dt-pdp-ab__form');
    var variantInput = productForm ? productForm.querySelector('[data-variant-input]') : root.querySelector('[data-variant-input]');
    var sellingPlanInput = productForm ? productForm.querySelector('[data-selling-plan-input]') : root.querySelector('[data-selling-plan-input]');
    var price = root.querySelector('[data-price]');
    var productTitle = root.querySelector('[data-product-title]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var comparePrice = root.querySelector('[data-compare-price]');
    var snapmintPriceSource = root.querySelector('[data-snapmint-price-source]');
    var selectedOptionsText = root.querySelector('[data-selected-options]');
    var addButton = productForm ? productForm.querySelector('[data-add-button]') : root.querySelector('[data-add-button]');
    var stickyAddButton = root.querySelector('[data-sticky-add-button]');
    var addButtonText = root.querySelector('[data-add-button-text]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var quantityValues = Array.prototype.slice.call(root.querySelectorAll('[data-qty-value]'));
    var quantityButtonsMinus = Array.prototype.slice.call(root.querySelectorAll('[data-qty-minus]'));
    var quantityButtonsPlus = Array.prototype.slice.call(root.querySelectorAll('[data-qty-plus]'));
    var fibreToggle = root.querySelector('[data-fibre-toggle]');
    var fibrePanel = fibreToggle ? document.getElementById(fibreToggle.getAttribute('aria-controls')) : null;
    var tipCards = Array.prototype.slice.call(root.querySelectorAll('[data-tip-card]'));
    var towelNeedsToggle = root.querySelector('[data-towel-needs-toggle]');
    var towelNeedsPanel = towelNeedsToggle ? document.getElementById(towelNeedsToggle.getAttribute('aria-controls')) : null;
    var towelNeedsCloseButtons = Array.prototype.slice.call(root.querySelectorAll('[data-towel-needs-close]'));
    var towelNeedCards = Array.prototype.slice.call(root.querySelectorAll('[data-towel-need-card]'));
    var singleTowelSwatches = root.querySelector('[data-single-towel-swatches]');
    var singleTowelSwatchButtons = Array.prototype.slice.call(root.querySelectorAll('[data-single-towel-swatch]'));
    var packTowelSwatchGroups = Array.prototype.slice.call(root.querySelectorAll('[data-pack-towel-swatches]'));
    var packTowelSwatchButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pack-towel-swatch]'));
    var detailItems = Array.prototype.slice.call(root.querySelectorAll('details.dt-pdp-ab__detail-item'));
    var detailSheet = root.querySelector('[data-detail-sheet]');
    var detailSheetTitle = detailSheet ? detailSheet.querySelector('[data-detail-sheet-title]') : null;
    var detailSheetBody = detailSheet ? detailSheet.querySelector('[data-detail-sheet-body]') : null;
    var detailSheetCloseButtons = detailSheet ? Array.prototype.slice.call(detailSheet.querySelectorAll('[data-detail-sheet-close]')) : [];
    var detailSheetCountdownTimer = null;
    var lastDetailSheetTrigger = null;
    var activeCouponSheet = null;
    var lastCouponTrigger = null;
    var gallery = root.querySelector('[data-gallery]');
    var showGallerySlide = null;
    var refreshGallerySlides = null;
    var baseProductTitle = productTitle ? productTitle.textContent.trim() : '';
    var currentPriceCents = Number(productForm && productForm.dataset.productPrice || 0);
    var currentIsAvailable = !(addButton && addButton.disabled);
    var currentUnavailableLabel = currentIsAvailable ? '' : (addButtonText ? addButtonText.textContent : 'Sold out');

    function getQuantity() {
      return Math.max(1, Number(quantityValues[0] && quantityValues[0].textContent || quantityInput && quantityInput.value) || 1);
    }

    function getAddToCartLabel() {
      return currentPriceCents ? 'Add to cart - ' + formatMoney(currentPriceCents * getQuantity(), moneyFormat) : 'Add to cart';
    }

    function updateStickyTotal() {
      if (stickyPrice && currentPriceCents) stickyPrice.textContent = formatMoney(currentPriceCents * getQuantity(), moneyFormat);
    }

    function setCurrentPrice(priceCents) {
      if (priceCents) currentPriceCents = Number(priceCents);
      updateStickyTotal();
    }

    function updateCtaState(isAvailable, unavailableLabel) {
      currentIsAvailable = !!isAvailable;
      if (!currentIsAvailable) currentUnavailableLabel = unavailableLabel || currentUnavailableLabel || 'Sold out';

      var label = currentIsAvailable ? getAddToCartLabel() : currentUnavailableLabel;
      if (addButton) addButton.disabled = !currentIsAvailable;
      if (addButtonText) addButtonText.textContent = label;
      if (stickyAddButton) {
        stickyAddButton.disabled = !currentIsAvailable;
        stickyAddButton.textContent = label;
      }
      updateStickyTotal();
    }

    function updateOptimisticFormData(data) {
      if (!productForm || !data) return;

      if (data.productTitle) productForm.dataset.productTitle = data.productTitle;

      if (data.variantId) {
        var baseUrl = (data.productUrl || productForm.dataset.productUrl || window.location.pathname).split('?')[0];
        productForm.dataset.productUrl = baseUrl + '?variant=' + data.variantId;
        syncBrowserUrl(data.productUrl || productForm.dataset.productUrl, data.variantId);
      }
      if (data.price) productForm.dataset.productPrice = String(data.price);

      if (data.image) {
        productForm.dataset.productImage = data.image;
        productForm.dataset.productImageAlt = data.imageAlt || productForm.dataset.productTitle || '';
      }

      if (data.variantTitle && data.variantTitle !== 'Default Title') {
        productForm.dataset.productVariantTitle = data.variantTitle;
        productForm.dataset.productVariantOptionName = data.variantOptionName || 'Color';
      } else {
        productForm.removeAttribute('data-product-variant-title');
        productForm.removeAttribute('data-product-variant-option-name');
      }
      productForm.dispatchEvent(new Event('dt:pdp-selection-change'));
    }

    function syncBrowserUrl(productUrl, variantId) {
      if (!variantId) return;

      try {
        var nextUrl = new URL(productUrl || window.location.pathname, window.location.href);
        nextUrl.searchParams.set('variant', String(variantId));
        var nextPath = nextUrl.pathname + nextUrl.search + nextUrl.hash;
        var currentPath = window.location.pathname + window.location.search + window.location.hash;

        if (nextPath !== currentPath) window.history.replaceState(window.history.state, '', nextPath);
      } catch (error) {
        // URL syncing is additive; selection and cart behavior should continue if it fails.
      }
    }

    function updateSellingPlanInput(source) {
      if (!sellingPlanInput) return;
      var sellingPlanId = source && source.getAttribute('data-towel-selling-plan-id') || '';

      sellingPlanInput.value = sellingPlanId;
      sellingPlanInput.disabled = !sellingPlanId;
    }

    function updateSnapmintPrice(priceCents) {
      if (!priceCents) return;
      if (snapmintPriceSource) snapmintPriceSource.textContent = formatMoney(priceCents, moneyFormat);

      var widget = root.querySelector('#sm-widget-btn.snap_emi_txt');
      if (!widget) return;

      widget.setAttribute('data-widget', String(Math.round(Number(priceCents) / 100)));
      var emiAmount = widget.querySelector('#dp, .dp-class');
      if (emiAmount) emiAmount.textContent = Math.round(Number(priceCents) / 300).toLocaleString('en-IN');
    }

    function updateProductTitle(isPack) {
      if (!productTitle || !baseProductTitle) return;
      productTitle.textContent = isPack && !/towels$/i.test(baseProductTitle)
        ? baseProductTitle.replace(/towel$/i, 'Towels')
        : baseProductTitle;
    }

    function updateSingleTowelSwatches(card) {
      if (!singleTowelSwatches || !card) return;
      singleTowelSwatches.toggleAttribute('data-is-visible', card.getAttribute('data-towel-quantity') === 'single');
    }

    function activePackSwatchGroup(card) {
      if (!card) return null;
      var packKey = card.getAttribute('data-pack-key');

      return packTowelSwatchGroups.find(function (group) {
        return group.getAttribute('data-pack-key') === packKey;
      }) || null;
    }

    function updatePackTowelSwatches(card) {
      var activeGroup = activePackSwatchGroup(card);

      packTowelSwatchGroups.forEach(function (group) {
        var isVisible = group === activeGroup;
        group.toggleAttribute('data-is-visible', isVisible);
        group.hidden = !isVisible;
      });
    }

    function selectedPackSwatch(card) {
      var group = activePackSwatchGroup(card);
      var buttons = group ? Array.prototype.slice.call(group.querySelectorAll('[data-pack-towel-swatch]')) : [];
      if (!buttons.length) return null;

      return buttons.find(function (button) {
        return button.getAttribute('data-towel-variant-id') === card.getAttribute('data-towel-variant-id');
      }) || buttons.find(function (button) {
        return button.getAttribute('aria-pressed') === 'true';
      }) || buttons.find(function (button) {
        return button.getAttribute('data-towel-available') !== 'false';
      }) || buttons[0];
    }

    function copySwatchDataToPackCard(button, card) {
      if (!button || !card) return;
      [
        'data-towel-variant-id',
        'data-towel-price',
        'data-towel-compare-price',
        'data-towel-available',
        'data-towel-product-title',
        'data-towel-product-url',
        'data-towel-variant-title',
        'data-towel-requires-selling-plan',
        'data-towel-selling-plan-id'
      ].forEach(function (attribute) {
        var value = button.getAttribute(attribute);
        if (value) {
          card.setAttribute(attribute, value);
        } else {
          card.removeAttribute(attribute);
        }
      });

      card.setAttribute('data-towel-variant-option-name', button.getAttribute('data-option-name') || 'Color');
      if (button.getAttribute('data-towel-image')) {
        card.setAttribute('data-towel-selected-image', button.getAttribute('data-towel-image'));
        card.setAttribute('data-towel-selected-image-alt', button.getAttribute('data-towel-image-alt') || '');
      }
    }

    function imageAttributeCount(source) {
      if (!source) return 0;
      var count = 0;

      for (var index = 1; source.getAttribute('data-towel-image-' + index); index += 1) {
        count = index;
      }

      return count;
    }

    function gallerySlides() {
      return gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]')) : [];
    }

    function currentProductGalleryImages() {
      return gallerySlides().map(function (slide) {
        if (slide.hasAttribute('data-gallery-persistent')) return null;
        var image = slide.querySelector('img:not(.dt-pdp-ab__badge)');
        if (!image) return null;

        return {
          src: image.currentSrc || image.src,
          width: image.getAttribute('width') || image.naturalWidth || image.width,
          height: image.getAttribute('height') || image.naturalHeight || image.height,
          alt: image.alt
        };
      }).filter(Boolean);
    }

    function ensureGallerySlides(count) {
      if (!gallery || !count) return [];

      var track = gallery.querySelector('.dt-pdp-ab__track');
      var slides = gallerySlides().filter(function (slide) {
        return !slide.hasAttribute('data-gallery-persistent');
      });
      if (!track) return slides;

      while (slides.length < count) {
        var slide = document.createElement('figure');
        var image = document.createElement('img');

        slide.className = 'dt-pdp-ab__slide';
        slide.setAttribute('data-slide', '');
        slide.setAttribute('aria-hidden', 'true');
        image.loading = 'lazy';
        image.alt = '';
        slide.appendChild(image);
        track.appendChild(slide);
        slides.push(slide);
      }

      return slides;
    }

    function syncShopifyVideoSlideOrder() {
      if (!gallery) return;
      var track = gallery.querySelector('.dt-pdp-ab__track');
      if (!track) return;

      var slides = gallerySlides();
      var dynamicSlides = slides.filter(function (slide) {
        return !slide.hasAttribute('data-gallery-persistent');
      });
      var videoSlides = slides.filter(function (slide) {
        return slide.hasAttribute('data-gallery-persistent');
      }).sort(function (first, second) {
        return Number(first.getAttribute('data-gallery-media-position') || dynamicSlides.length)
          - Number(second.getAttribute('data-gallery-media-position') || dynamicSlides.length);
      });

      videoSlides.forEach(function (slide) {
        var position = Number(slide.getAttribute('data-gallery-media-position') || dynamicSlides.length);
        track.insertBefore(slide, dynamicSlides[position] || null);
      });

      var promoSlide = gallery.querySelector('[data-gallery-promo]');
      if (promoSlide && dynamicSlides[0]) {
        track.insertBefore(dynamicSlides[0], track.firstChild);
        dynamicSlides[0].after(promoSlide);
      }

      if (refreshGallerySlides) refreshGallerySlides();
    }

    function imageUrlKey(url) {
      return String(url || '').split('?')[0].replace(/^(?:https?:)?\/\/[^/]+/, '');
    }

    function indexedGalleryImages(source) {
      var images = [];
      var imageCount = imageAttributeCount(source);

      for (var imageIndex = 1; imageIndex <= imageCount; imageIndex += 1) {
        var src = source.getAttribute('data-towel-image-' + imageIndex);
        if (!src) continue;

        images.push({
          src: src,
          width: source.getAttribute('data-towel-image-width-' + imageIndex),
          height: source.getAttribute('data-towel-image-height-' + imageIndex),
          alt: source.getAttribute('data-towel-image-alt-' + imageIndex)
        });
      }

      return images;
    }

    function rotateGalleryImages(images, startSrc, button) {
      if (!images.length || !startSrc) return images;
      var startKey = imageUrlKey(startSrc);
      var startIndex = images.findIndex(function (item) {
        return imageUrlKey(item.src) === startKey;
      });
      var selected = {
        src: startSrc,
        width: button && button.getAttribute('data-towel-image-width') || (images[startIndex] && images[startIndex].width),
        height: button && button.getAttribute('data-towel-image-height') || (images[startIndex] && images[startIndex].height),
        alt: button && button.getAttribute('data-towel-image-alt') || (images[startIndex] && images[startIndex].alt)
      };
      if (startIndex < 0) return [selected].concat(images);
      return [selected].concat(images.slice(startIndex + 1), images.slice(0, startIndex));
    }

    function renderGalleryImages(images) {
      if (!gallery || !images.length) return;
      var status = gallery.querySelector('[data-gallery-status]');
      ensureGallerySlides(images.length);
      syncShopifyVideoSlideOrder();
      var slides = gallerySlides().filter(function (slide) {
        return !slide.hasAttribute('data-gallery-persistent');
      });

      setGallerySlideCount(images.length);
      slides.forEach(function (slide, index) {
        var imageData = images[index];
        var image = slide.querySelector('img:not(.dt-pdp-ab__badge)');
        if (!image || !imageData) return;

        image.src = imageData.src;
        image.setAttribute('data-src', imageData.src);
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.removeAttribute('data-srcset');
        image.width = Number(imageData.width || image.width || 1200);
        image.height = Number(imageData.height || image.height || 1200);
        image.alt = imageData.alt || image.alt || '';

        if (index === 0) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      if (status) status.textContent = '1 / ' + images.length;
      if (showGallerySlide) showGallerySlide(0);
    }

    function updatePackGallery(card) {
      if (!gallery || !card) return;
      renderGalleryImages(indexedGalleryImages(card));
    }

    function updateSingleProductGallery(card, button) {
      if (!card) return;
      var images = indexedGalleryImages(card);
      var selectedImage = button && button.getAttribute('data-towel-image');

      if (selectedImage) {
        images = rotateGalleryImages(images, selectedImage, button);
      }

      renderGalleryImages(images);
    }

    function setGallerySlideCount(count) {
      if (!gallery || !count) return;
      ensureGallerySlides(count);
      syncShopifyVideoSlideOrder();
      var slides = gallerySlides();
      var dynamicSlides = slides.filter(function (slide) {
        return !slide.hasAttribute('data-gallery-persistent');
      });
      var status = gallery.querySelector('[data-gallery-status]');

      slides.forEach(function (slide) {
        if (slide.hasAttribute('data-gallery-persistent')) {
          slide.hidden = false;
          slide.removeAttribute('data-gallery-disabled');
          return;
        }

        var dynamicIndex = dynamicSlides.indexOf(slide);
        var isEnabled = dynamicIndex < count;
        slide.hidden = !isEnabled;
        if (isEnabled) {
          slide.removeAttribute('data-gallery-disabled');
        } else {
          slide.setAttribute('data-gallery-disabled', 'true');
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      if (status) status.textContent = '1 / ' + count;
    }

    function updateSingleTowelGallery(button) {
      if (!gallery || !button) return;
      var indexedImageCount = imageAttributeCount(button);
      if (indexedImageCount) {
        var demoSlides = ensureGallerySlides(indexedImageCount);
        setGallerySlideCount(indexedImageCount);

        demoSlides.forEach(function (slide, index) {
          var imageIndex = index + 1;
          var image = slide.querySelector('img:not(.dt-pdp-ab__badge)');
          var src = button.getAttribute('data-towel-image-' + imageIndex);
          if (!image || !src) return;

          image.src = src;
          image.setAttribute('data-src', src);
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.removeAttribute('data-srcset');
          image.width = Number(button.getAttribute('data-towel-image-width-' + imageIndex) || image.width || 1400);
          image.height = Number(button.getAttribute('data-towel-image-height-' + imageIndex) || image.height || 1680);
          image.alt = button.getAttribute('data-towel-image-alt-' + imageIndex) || image.alt || '';
        });

        if (showGallerySlide) showGallerySlide(0);
        return;
      }

      setGallerySlideCount(gallerySlides().filter(function (slide) {
        return !slide.hasAttribute('data-gallery-persistent');
      }).length);
      var imageSrc = button.getAttribute('data-towel-image');
      if (!imageSrc) return;

      var firstSlide = gallery.querySelector('[data-slide]');
      var firstImage = firstSlide ? firstSlide.querySelector('img:not(.dt-pdp-ab__badge)') : null;
      if (!firstImage) return;

      firstImage.src = imageSrc;
      firstImage.setAttribute('data-src', imageSrc);
      firstImage.removeAttribute('srcset');
      firstImage.removeAttribute('sizes');
      firstImage.removeAttribute('data-srcset');
      firstImage.width = Number(button.getAttribute('data-towel-image-width') || firstImage.width || 1200);
      firstImage.height = Number(button.getAttribute('data-towel-image-height') || firstImage.height || 1200);
      firstImage.alt = button.getAttribute('data-towel-image-alt') || button.getAttribute('data-option-value') || firstImage.alt || '';

      if (showGallerySlide) showGallerySlide(0);
    }

    function applyPackCard(card) {
      if (!card) return;
      updateSingleTowelSwatches(card);
      updatePackTowelSwatches(card);

      var swatch = selectedPackSwatch(card);
      if (swatch) {
        applyPackTowelSwatch(swatch, card);
        return;
      }

      var variantId = card.getAttribute('data-towel-variant-id');
      var packPrice = Number(card.getAttribute('data-towel-price') || 0);
      var packComparePrice = Number(card.getAttribute('data-towel-compare-price') || 0);
      var isAvailable = card.getAttribute('data-towel-available') !== 'false' && !!variantId;
      var towelNeedsSection = root.querySelector('.dt-pdp-ab__towel-needs');

      if (towelNeedsSection) towelNeedsSection.classList.add('is-guidance-visible');
      towelNeedCards.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item === card));
      });
      updateProductTitle(card.getAttribute('data-towel-quantity') === 'pack');

      if (variantInput && variantId) variantInput.value = variantId;
      updateSellingPlanInput(card);
      if (price && packPrice) price.textContent = formatMoney(packPrice, moneyFormat);
      setCurrentPrice(packPrice);
      updateSnapmintPrice(packPrice);
      if (comparePrice) {
        var hasCompare = packComparePrice && packComparePrice > packPrice;
        comparePrice.hidden = !hasCompare;
        comparePrice.textContent = hasCompare ? formatMoney(packComparePrice, moneyFormat) : '';
      }

      updateCtaState(isAvailable, 'Sold out');
      updatePackGallery(card);
      updateOptimisticFormData({
        variantId: variantId,
        price: packPrice,
        productTitle: card.getAttribute('data-towel-product-title') || '',
        productUrl: card.getAttribute('data-towel-product-url') || '',
        image: card.getAttribute('data-towel-image-1') || '',
        imageAlt: card.getAttribute('data-towel-image-alt-1') || '',
        variantTitle: card.getAttribute('data-towel-variant-title') || '',
        variantOptionName: card.getAttribute('data-towel-variant-option-name') || 'Color'
      });
    }

    function applyPackTowelSwatch(button, packCard) {
      if (!button) return;
      var card = packCard || towelNeedCards.find(function (item) {
        return item.getAttribute('data-pack-key') === button.getAttribute('data-pack-key');
      });
      if (!card) return;

      copySwatchDataToPackCard(button, card);

      var variantId = button.getAttribute('data-towel-variant-id');
      var swatchPrice = Number(button.getAttribute('data-towel-price') || 0);
      var swatchComparePrice = Number(button.getAttribute('data-towel-compare-price') || 0);
      var isAvailable = button.getAttribute('data-towel-available') !== 'false' && !!variantId;
      var group = button.closest('[data-pack-towel-swatches]');

      towelNeedCards.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item === card));
      });

      if (group) {
        Array.prototype.slice.call(group.querySelectorAll('[data-pack-towel-swatch]')).forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === button));
        });
        var selectedText = group.querySelector('[data-pack-selected-options]');
        if (selectedText && button.getAttribute('data-option-value')) {
          selectedText.textContent = button.getAttribute('data-option-value');
        }
      }

      updateSingleTowelSwatches(card);
      updatePackTowelSwatches(card);
      updateProductTitle(card.getAttribute('data-towel-quantity') === 'pack');

      if (variantInput && variantId) variantInput.value = variantId;
      updateSellingPlanInput(button);
      if (price && swatchPrice) price.textContent = formatMoney(swatchPrice, moneyFormat);
      setCurrentPrice(swatchPrice);
      updateSnapmintPrice(swatchPrice);
      if (selectedOptionsText && button.getAttribute('data-option-value')) {
        selectedOptionsText.textContent = button.getAttribute('data-option-value');
      }
      if (comparePrice) {
        var hasCompare = swatchComparePrice && swatchComparePrice > swatchPrice;
        comparePrice.hidden = !hasCompare;
        comparePrice.textContent = hasCompare ? formatMoney(swatchComparePrice, moneyFormat) : '';
      }

      updateCtaState(isAvailable, 'Sold out');
      updateSingleProductGallery(card, button);
      updateOptimisticFormData({
        variantId: variantId,
        price: swatchPrice,
        productTitle: button.getAttribute('data-towel-product-title') || card.getAttribute('data-towel-product-title') || '',
        productUrl: button.getAttribute('data-towel-product-url') || card.getAttribute('data-towel-product-url') || '',
        image: button.getAttribute('data-towel-image') || card.getAttribute('data-towel-image-1') || '',
        imageAlt: button.getAttribute('data-towel-image-alt') || card.getAttribute('data-towel-image-alt-1') || '',
        variantTitle: button.getAttribute('data-towel-variant-title') || '',
        variantOptionName: button.getAttribute('data-option-name') || 'Color'
      });
    }

    function applySingleTowelSwatch(button) {
      if (!button) return;
      var singleCard = root.querySelector('[data-towel-quantity="single"]');
      var variantId = button.getAttribute('data-towel-variant-id');
      var swatchPrice = Number(button.getAttribute('data-towel-price') || 0);
      var swatchComparePrice = Number(button.getAttribute('data-towel-compare-price') || 0);
      var isAvailable = button.getAttribute('data-towel-available') !== 'false' && !!variantId;

      singleTowelSwatchButtons.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item === button));
      });

      if (singleCard) {
        singleCard.setAttribute('data-towel-variant-id', variantId || '');
        singleCard.setAttribute('data-towel-price', String(swatchPrice || 0));
        singleCard.setAttribute('data-towel-compare-price', String(swatchComparePrice || 0));
        singleCard.setAttribute('data-towel-available', String(isAvailable));
        singleCard.setAttribute('aria-pressed', 'true');
        towelNeedCards.forEach(function (item) {
          if (item !== singleCard) item.setAttribute('aria-pressed', 'false');
        });
        updateSingleTowelSwatches(singleCard);
      }

      if (variantInput && variantId) variantInput.value = variantId;
      if (price && swatchPrice) price.textContent = formatMoney(swatchPrice, moneyFormat);
      setCurrentPrice(swatchPrice);
      updateSnapmintPrice(swatchPrice);
      if (selectedOptionsText && button.getAttribute('data-option-value')) {
        selectedOptionsText.textContent = button.getAttribute('data-option-value');
      }
      updateProductTitle(false);
      if (comparePrice) {
        var hasCompare = swatchComparePrice && swatchComparePrice > swatchPrice;
        comparePrice.hidden = !hasCompare;
        comparePrice.textContent = hasCompare ? formatMoney(swatchComparePrice, moneyFormat) : '';
      }
      updateCtaState(isAvailable, 'Sold out');
      if (singleCard) {
        updateSingleProductGallery(singleCard, button);
      } else {
        renderGalleryImages(rotateGalleryImages(baseProductGalleryImages, button.getAttribute('data-towel-image'), button));
      }
      updateOptimisticFormData({
        variantId: variantId,
        price: swatchPrice,
        image: button.getAttribute('data-towel-image-1') || button.getAttribute('data-towel-image') || '',
        imageAlt: button.getAttribute('data-towel-image-alt-1') || button.getAttribute('data-towel-image-alt') || '',
        variantTitle: button.getAttribute('data-option-value') || '',
        variantOptionName: 'Color'
      });
    }

    optionButtons.forEach(function (button) {
      selectedOptions[Number(button.dataset.optionIndex)] = selectedOptions[Number(button.dataset.optionIndex)] || button.dataset.optionValue;
      if (button.getAttribute('aria-pressed') === 'true') {
        selectedOptions[Number(button.dataset.optionIndex)] = button.dataset.optionValue;
      }
    });

    function selectedVariantFromInput() {
      if (!variantInput || !variantInput.value) return null;

      return variants.find(function (variant) {
        return String(variant.id) === String(variantInput.value);
      }) || null;
    }

    function fallbackVariant() {
      return selectedVariantFromInput() || variants.find(function (variant) {
        return variant.available;
      }) || variants[0] || null;
    }

    function hasCompleteOptionSelection() {
      var referenceVariant = variants[0];
      if (!referenceVariant || !referenceVariant.options) return false;

      return referenceVariant.options.every(function (_optionValue, index) {
        return selectedOptions[index] !== undefined;
      });
    }

    function selectedVariant() {
      if (!optionButtons.length || !hasCompleteOptionSelection()) return fallbackVariant();

      return variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return String(optionValue) === String(selectedOptions[index]);
        });
      }) || fallbackVariant();
    }

    function updateVariant() {
      var variant = selectedVariant();
      if (!variant) {
        updateCtaState(false, 'Sold out');
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, moneyFormat);
      setCurrentPrice(variant.price);
      updateSnapmintPrice(variant.price);
      if (selectedOptionsText) selectedOptionsText.textContent = variant.options.join(' / ');

      if (comparePrice) {
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        comparePrice.hidden = !hasCompare;
        comparePrice.textContent = hasCompare ? formatMoney(variant.compare_at_price, moneyFormat) : '';
      }

      updateCtaState(variant.available, 'Sold out');
      updateOptimisticFormData({
        variantId: variant.id,
        price: variant.price,
        image: variant.featured_image ? variant.featured_image.src : '',
        imageAlt: variant.featured_image ? variant.featured_image.alt : '',
        variantTitle: selectedOptionsText ? selectedOptionsText.textContent : '',
        variantOptionName: 'Color'
      });
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.dataset.optionIndex);
        selectedOptions[index] = button.dataset.optionValue;

        optionButtons.forEach(function (item) {
          if (Number(item.dataset.optionIndex) === index) {
            item.setAttribute('aria-pressed', String(item === button));
          }
        });

        updateVariant();
      });
    });

    function setQuantity(value) {
      var nextValue = Math.max(1, value);
      quantityValues.forEach(function (quantityValue) {
        quantityValue.textContent = String(nextValue);
      });
      if (quantityInput) quantityInput.value = String(nextValue);
      updateCtaState(currentIsAvailable, currentUnavailableLabel);
      if (productForm) productForm.dispatchEvent(new Event('dt:pdp-selection-change'));
    }

    quantityButtonsMinus.forEach(function (quantityMinus) {
      quantityMinus.addEventListener('click', function () {
        setQuantity((Number(quantityValues[0] && quantityValues[0].textContent) || 1) - 1);
      });
    });

    quantityButtonsPlus.forEach(function (quantityPlus) {
      quantityPlus.addEventListener('click', function () {
        setQuantity((Number(quantityValues[0] && quantityValues[0].textContent) || 1) + 1);
      });
    });

    if (fibreToggle) {
      fibreToggle.addEventListener('click', function () {
        var isOpen = fibreToggle.getAttribute('aria-expanded') === 'true';
        fibreToggle.setAttribute('aria-expanded', String(!isOpen));
        if (fibrePanel) fibrePanel.hidden = isOpen;
      });
    }

    tipCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var proof = card.querySelector('.dt-pdp-ab__tip-proof');
        var shouldOpen = card.getAttribute('aria-expanded') !== 'true';

        tipCards.forEach(function (item) {
          item.classList.remove('is-open');
          item.setAttribute('aria-expanded', 'false');
          var itemProof = item.querySelector('.dt-pdp-ab__tip-proof');
          if (itemProof) itemProof.setAttribute('aria-hidden', 'true');
        });

        if (!shouldOpen) return;

        card.classList.add('is-open');
        card.setAttribute('aria-expanded', 'true');
        if (proof) proof.setAttribute('aria-hidden', 'false');
      });
    });

    if (towelNeedsToggle && towelNeedsPanel && towelNeedsToggle.dataset.sheetBound !== 'true') {
      towelNeedsToggle.dataset.sheetBound = 'true';

      function closeTowelNeedsSheet() {
        towelNeedsToggle.setAttribute('aria-expanded', 'false');
        towelNeedsPanel.classList.remove('is-open');
        document.documentElement.classList.remove('dt-pdp-ab-sheet-open');
        window.setTimeout(function () {
          if (!towelNeedsPanel.classList.contains('is-open')) towelNeedsPanel.hidden = true;
        }, 260);
      }

      function openTowelNeedsSheet() {
        towelNeedsToggle.setAttribute('aria-expanded', 'true');
        towelNeedsPanel.hidden = false;
        document.documentElement.classList.add('dt-pdp-ab-sheet-open');
        requestAnimationFrame(function () {
          towelNeedsPanel.classList.add('is-open');
        });
      }

      towelNeedsToggle.addEventListener('click', function () {
        if (towelNeedsToggle.getAttribute('aria-expanded') === 'true') {
          closeTowelNeedsSheet();
          return;
        }
        openTowelNeedsSheet();
      });

      towelNeedsCloseButtons.forEach(function (button) {
        button.addEventListener('click', closeTowelNeedsSheet);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && towelNeedsToggle.getAttribute('aria-expanded') === 'true') {
          closeTowelNeedsSheet();
        }
      });
    }

    function closeDetailSheet() {
      if (!detailSheet || detailSheet.hidden) return;

      detailSheet.classList.remove('is-open');
      detailSheet.classList.remove('is-visible');
      document.documentElement.classList.remove('dt-pdp-ab-sheet-open');
      if (detailSheetCountdownTimer) {
        window.clearInterval(detailSheetCountdownTimer);
        detailSheetCountdownTimer = null;
      }
      detailSheet.addEventListener('transitionend', function hideSheet(event) {
        if (event.target !== detailSheet || detailSheet.classList.contains('is-visible')) return;
        detailSheet.hidden = true;
        detailSheet.removeEventListener('transitionend', hideSheet);
      });
      setTimeout(function () {
        if (!detailSheet.classList.contains('is-visible')) detailSheet.hidden = true;
      }, 440);

      if (lastDetailSheetTrigger) lastDetailSheetTrigger.focus();
    }

    function updateDetailSheetCountdown() {
      if (!detailSheetBody) return;
      var countdown = detailSheetBody.querySelector('[data-delivery-countdown]');
      if (!countdown) return;

      var now = new Date();
      var cutoffHours = [3, 15, 19];
      var nextCutoffHour = cutoffHours.find(function (hour) {
        return now.getHours() < hour || (now.getHours() === hour && now.getMinutes() === 0 && now.getSeconds() === 0);
      });
      var cutoff = new Date(now.getTime());

      if (typeof nextCutoffHour === 'number') {
        cutoff.setHours(nextCutoffHour, 0, 0, 0);
      } else {
        cutoff.setDate(cutoff.getDate() + 1);
        cutoff.setHours(3, 0, 0, 0);
      }

      var diff = Math.max(0, cutoff.getTime() - now.getTime());
      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      countdown.textContent = [hours, minutes, seconds].map(function (value) {
        return String(value).padStart(2, '0');
      }).join(':');
    }

    function populateDetailSheet(button) {
      if (!detailSheetBody || !button) return;
      var sheetKey = button.getAttribute('data-sheet-content') || button.getAttribute('data-sheet-title') || '';
      var template = root.querySelector('[data-detail-sheet-template="' + sheetKey.replace(/"/g, '\\"') + '"]');

      detailSheetBody.innerHTML = template ? template.innerHTML : '';

      if (sheetKey === 'Express Delivery') {
        updateDetailSheetCountdown();
        detailSheetCountdownTimer = window.setInterval(updateDetailSheetCountdown, 1000);
      }
    }

    function openDetailSheet(button) {
      if (!detailSheet || !button) return;

      if (detailSheetCountdownTimer) {
        window.clearInterval(detailSheetCountdownTimer);
        detailSheetCountdownTimer = null;
      }
      lastDetailSheetTrigger = button;
      var sheetKey = button.getAttribute('data-sheet-content') || button.getAttribute('data-sheet-title') || '';
      detailSheet.setAttribute('data-detail-sheet-key', sheetKey);
      if (detailSheetTitle) detailSheetTitle.textContent = button.getAttribute('data-sheet-title') || '';
      populateDetailSheet(button);
      detailSheet.hidden = false;
      document.documentElement.classList.add('dt-pdp-ab-sheet-open');
      detailSheet.offsetHeight;
      detailSheet.classList.add('is-visible');
      var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
      var openSheet = function () {
        detailSheet.classList.add('is-open');
        var closeButton = detailSheet.querySelector('.dt-pdp-ab__sheet-close');
        if (closeButton) closeButton.focus();
      };

      if (isDesktop) {
        openSheet();
      } else {
        window.setTimeout(openSheet, 160);
      }
    }

    function restoreCouponSheet(sheet) {
      var placeholder = sheet && sheet._dtPdpCouponPlaceholder;
      if (!sheet || !placeholder || !placeholder.parentNode) return;

      placeholder.parentNode.insertBefore(sheet, placeholder);
      placeholder.remove();
      sheet._dtPdpCouponPlaceholder = null;
    }

    function closeCouponSheet() {
      var sheet = activeCouponSheet;
      if (!sheet) return;

      sheet.setAttribute('aria-hidden', 'true');
      if (lastCouponTrigger) lastCouponTrigger.setAttribute('aria-expanded', 'false');
      activeCouponSheet = null;

      window.setTimeout(function () {
        restoreCouponSheet(sheet);
        if (lastCouponTrigger) lastCouponTrigger.focus();
      }, 320);
    }

    function openCouponSheet(trigger) {
      var card = trigger && trigger.closest('.offers-coupon-card');
      var sheet = card && card.querySelector('[data-next-order-coupon-sheet]');
      if (!sheet) return;

      lastCouponTrigger = trigger;
      activeCouponSheet = sheet;
      trigger.setAttribute('aria-expanded', 'true');

      sheet._dtPdpCouponPlaceholder = document.createComment('dt-pdp-coupon-sheet');
      sheet.parentNode.insertBefore(sheet._dtPdpCouponPlaceholder, sheet);
      document.body.appendChild(sheet);
      sheet.setAttribute('aria-hidden', 'false');

      if (!sheet._dtPdpCouponEventsReady) {
        sheet._dtPdpCouponEventsReady = true;
        sheet.addEventListener('click', function (event) {
          if (!event.target.closest('[data-next-order-terms-close]')) return;
          event.preventDefault();
          event.stopPropagation();
          closeCouponSheet();
        });
      }

      window.requestAnimationFrame(function () {
        var closeButton = sheet.querySelector('.dt-next-order-coupon-sheet__close');
        if (closeButton) closeButton.focus();
      });
    }

    function finishDetailAnimation(detail, shouldOpen) {
      detail.style.height = '';
      detail.style.overflow = '';
      detail.style.willChange = '';
      detail._dtAnimation = null;
      if (!shouldOpen) detail.open = false;
    }

    function setDetailOpen(detail, shouldOpen) {
      var summary = detail.querySelector('summary');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!summary) return;

      if (detail._dtAnimation) {
        detail._dtAnimation.onfinish = null;
        detail._dtAnimation.oncancel = null;
        detail._dtAnimation.cancel();
        detail._dtAnimation = null;
      }

      if (reduceMotion || typeof detail.animate !== 'function') {
        detail.open = shouldOpen;
        detail.setAttribute('data-detail-expanded', String(shouldOpen));
        return;
      }

      var startHeight = detail.offsetHeight;
      if (shouldOpen) detail.open = true;
      var endHeight = shouldOpen ? detail.scrollHeight : summary.offsetHeight;

      detail.setAttribute('data-detail-expanded', String(shouldOpen));
      detail.style.overflow = 'hidden';
      detail.style.height = startHeight + 'px';
      detail.style.willChange = 'height';

      detail._dtAnimation = detail.animate({
        height: [startHeight + 'px', endHeight + 'px']
      }, {
        duration: 260,
        easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)'
      });

      detail._dtAnimation.onfinish = function () {
        finishDetailAnimation(detail, shouldOpen);
      };
      detail._dtAnimation.oncancel = function () {
        finishDetailAnimation(detail, detail.open);
      };
    }

    detailItems.forEach(function (detail) {
      var summary = detail.querySelector('summary');
      if (!summary) return;

      detail.setAttribute('data-detail-expanded', String(detail.open));
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        setDetailOpen(detail, !detail.open);
      });
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-detail-sheet-open]');
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      openDetailSheet(button);
    });

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-next-order-terms-open]');
      if (!trigger || !root.contains(trigger)) return;

      event.preventDefault();
      event.stopPropagation();
      openCouponSheet(trigger);
    });

    detailSheetCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeDetailSheet);
    });

    if (detailSheet) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && detailSheet && !detailSheet.hidden) closeDetailSheet();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !activeCouponSheet) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        closeCouponSheet();
      }, true);
    }

    var baseProductGalleryImages = currentProductGalleryImages();

    towelNeedCards.forEach(function (card) {
      card.addEventListener('click', function () {
        applyPackCard(card);
      });
    });

    singleTowelSwatchButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        applySingleTowelSwatch(button);
      });
    });

    packTowelSwatchButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        applyPackTowelSwatch(button);
      });
    });

    var activeTowelNeedCard = towelNeedCards.find(function (card) {
      return card.getAttribute('aria-pressed') === 'true';
    });
    if (activeTowelNeedCard) {
      updateSingleTowelSwatches(activeTowelNeedCard);
      updatePackTowelSwatches(activeTowelNeedCard);
    }
    if (activeTowelNeedCard && activeTowelNeedCard.getAttribute('data-towel-quantity') === 'single') {
      applySingleTowelSwatch(singleTowelSwatchButtons.find(function (button) {
        return button.getAttribute('aria-pressed') === 'true';
      }));
    }

    if (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
      refreshGallerySlides = function () {
        slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
      };
      syncShopifyVideoSlideOrder();
      var status = gallery.querySelector('[data-gallery-status]');
      var previous = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      var track = gallery.querySelector('.dt-pdp-ab__track');
      var useScrollGallery = gallery.hasAttribute('data-gallery-scroll') && track;
      var progressThumb = gallery.querySelector('[data-gallery-progress]');
      var activeIndex = 0;
      var scrollFrame = null;
      var zoomModal = null;
      var zoomImage = null;
      var zoomThumbs = null;
      var zoomCloseButton = null;
      var zoomPreviousButton = null;
      var zoomNextButton = null;
      var zoomThumbPreviousButton = null;
      var zoomThumbNextButton = null;
      var zoomLastTrigger = null;
      var zoomIndex = 0;
      var zoomScale = 1;
      var zoomTranslateX = 0;
      var zoomTranslateY = 0;
      var zoomStartDistance = 0;
      var zoomStartScale = 1;
      var zoomDragStart = null;
      var zoomSwipeStart = null;
      var galleryPointerStart = null;
      var galleryPointerMoved = false;

      function activeSlides() {
        return slides.filter(function (slide) {
          return !slide.hidden && !slide.hasAttribute('data-gallery-disabled');
        });
      }

      function updateGalleryProgress() {
        if (!useScrollGallery || !progressThumb) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var thumbWidth = progressThumb.offsetWidth;
        var maxLeft = Math.max(track.clientWidth - thumbWidth, 0);
        var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        progressThumb.style.setProperty('--dt-gallery-progress-left', Math.round(maxLeft * ratio) + 'px');
      }

      function loadGallerySlide(slide) {
        if (!slide) return;

        Array.prototype.forEach.call(slide.querySelectorAll('img[data-src]'), function (image) {
          var srcset = image.getAttribute('data-srcset');
          if (srcset) image.setAttribute('srcset', srcset);
          image.src = image.getAttribute('data-src');
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
        });
      }

      function updateGalleryState(index) {
        var enabledSlides = activeSlides();
        if (!enabledSlides.length) return;
        activeIndex = (index + enabledSlides.length) % enabledSlides.length;
        loadGallerySlide(enabledSlides[activeIndex]);

        slides.forEach(function (slide, slideIndex) {
          var video = slide.querySelector('video');
          var enabledIndex = enabledSlides.indexOf(slide);
          if (enabledIndex === activeIndex) {
            slide.removeAttribute('aria-hidden');
            if (video) video.play().catch(function () {});
          } else {
            slide.setAttribute('aria-hidden', 'true');
            if (video) video.pause();
          }
        });

        updateGalleryContrast(enabledSlides[activeIndex]);
        if (status) status.textContent = activeIndex + 1 + ' / ' + enabledSlides.length;
        updateGalleryProgress();
      }

      function updateGalleryContrast(activeSlide) {
        if (!activeSlide) return;
        var image = activeSlide.querySelector('img:not(.dt-pdp-ab__badge)');
        var src = image ? String(image.currentSrc || image.src || '').toLowerCase() : '';
        var alt = image ? String(image.alt || '').toLowerCase() : '';
        var key = src + ' ' + alt;
        var useLightControls = (
          key.indexOf('skin-shield') !== -1 ||
          key.indexOf('clinical') !== -1 ||
          key.indexOf('less acne') !== -1 ||
          key.indexOf('dark') !== -1
        );

        gallery.classList.toggle('is-contrast-light', useLightControls);
      }

      function currentScrollIndex() {
        var enabledSlides = activeSlides();
        if (!track || !enabledSlides.length) return activeIndex;
        var closestIndex = 0;
        var closestDistance = Infinity;

        enabledSlides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function imageFromSlide(slide) {
        var image = primarySlideImage(slide);
        if (!image) return null;

        return {
          src: bestImageSource(image),
          alt: image.alt || productForm && productForm.dataset.productTitle || baseProductTitle || 'Product image'
        };
      }

      function primarySlideImage(slide) {
        if (!slide) return null;
        return Array.prototype.slice.call(slide.children).find(function (child) {
          return child.tagName === 'IMG' && !child.classList.contains('dt-pdp-ab__badge');
        }) || null;
      }

      function bestImageSource(image) {
        var candidates = [];
        var srcset = image.getAttribute('srcset') || image.getAttribute('data-srcset') || '';

        srcset.split(',').forEach(function (candidate) {
          var parts = candidate.trim().split(/\s+/);
          var src = parts[0];
          var width = Number(parts[1] ? parts[1].replace('w', '') : 0);
          if (src) candidates.push({ src: src, width: width });
        });

        candidates.sort(function (a, b) { return b.width - a.width; });
        return candidates[0] && candidates[0].src || image.currentSrc || image.src || image.getAttribute('data-src') || '';
      }

      function zoomItems() {
        return activeSlides().map(imageFromSlide).filter(function (item) {
          return item && item.src;
        });
      }

      function updateZoomTransform() {
        if (!zoomImage) return;
        zoomImage.style.transform = 'translate3d(' + zoomTranslateX + 'px, ' + zoomTranslateY + 'px, 0) scale(' + zoomScale + ')';
      }

      function resetZoomTransform() {
        zoomScale = 1;
        zoomTranslateX = 0;
        zoomTranslateY = 0;
        zoomStartDistance = 0;
        zoomStartScale = 1;
        zoomDragStart = null;
        zoomSwipeStart = null;
        updateZoomTransform();
      }

      function updateZoomControls(items) {
        var hasMultipleImages = items.length > 1;
        [zoomPreviousButton, zoomNextButton, zoomThumbPreviousButton, zoomThumbNextButton].forEach(function (button) {
          if (!button) return;
          button.hidden = !hasMultipleImages;
          button.disabled = !hasMultipleImages;
        });
      }

      function scrollActiveZoomThumb() {
        if (!zoomThumbs) return;
        var activeThumb = zoomThumbs.querySelector('[aria-current="true"]');
        if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
          activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      function renderZoomThumbs(items) {
        if (!zoomThumbs) return;
        zoomThumbs.innerHTML = '';

        items.forEach(function (item, index) {
          var button = document.createElement('button');
          var image = document.createElement('img');

          button.type = 'button';
          button.className = 'dt-pdp-ab-zoom__thumb';
          button.setAttribute('aria-label', 'View product image ' + (index + 1));
          button.setAttribute('aria-current', String(index === zoomIndex));
          image.src = item.src;
          image.alt = '';
          image.loading = 'lazy';
          button.appendChild(image);
          button.addEventListener('click', function () {
            setZoomImage(index);
          });
          zoomThumbs.appendChild(button);
        });
        updateZoomControls(items);
        scrollActiveZoomThumb();
      }

      function setZoomImage(index) {
        var items = zoomItems();
        if (!items.length || !zoomImage) return;
        zoomIndex = (index + items.length) % items.length;
        zoomImage.src = items[zoomIndex].src;
        zoomImage.alt = items[zoomIndex].alt;
        resetZoomTransform();
        renderZoomThumbs(items);
      }

      function scrollZoomThumbs(direction) {
        if (!zoomThumbs) return;
        zoomThumbs.scrollBy({
          left: direction * Math.max(zoomThumbs.clientWidth * .75, 120),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      function closeZoomModal() {
        if (!zoomModal || zoomModal.hidden) return;
        zoomModal.classList.remove('is-open');
        document.documentElement.classList.remove('dt-pdp-ab-zoom-open');
        window.setTimeout(function () {
          if (zoomModal && !zoomModal.classList.contains('is-open')) zoomModal.hidden = true;
        }, 180);
        resetZoomTransform();
        if (zoomLastTrigger) zoomLastTrigger.focus();
      }

      function touchDistance(touches) {
        var dx = touches[0].clientX - touches[1].clientX;
        var dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      function bindZoomTouch(stage) {
        stage.addEventListener('touchstart', function (event) {
          if (event.touches.length === 2) {
            zoomStartDistance = touchDistance(event.touches);
            zoomStartScale = zoomScale;
            zoomDragStart = null;
            zoomSwipeStart = null;
          } else if (event.touches.length === 1 && zoomScale > 1) {
            zoomDragStart = {
              x: event.touches[0].clientX,
              y: event.touches[0].clientY,
              translateX: zoomTranslateX,
              translateY: zoomTranslateY
            };
            zoomSwipeStart = null;
          } else if (event.touches.length === 1) {
            zoomSwipeStart = {
              x: event.touches[0].clientX,
              y: event.touches[0].clientY
            };
          }
        }, { passive: true });

        stage.addEventListener('touchmove', function (event) {
          if (event.touches.length === 2 && zoomStartDistance) {
            event.preventDefault();
            zoomScale = Math.min(Math.max(zoomStartScale * touchDistance(event.touches) / zoomStartDistance, 1), 4);
            if (zoomScale === 1) {
              zoomTranslateX = 0;
              zoomTranslateY = 0;
            }
            updateZoomTransform();
          } else if (event.touches.length === 1 && zoomDragStart && zoomScale > 1) {
            event.preventDefault();
            zoomTranslateX = zoomDragStart.translateX + event.touches[0].clientX - zoomDragStart.x;
            zoomTranslateY = zoomDragStart.translateY + event.touches[0].clientY - zoomDragStart.y;
            updateZoomTransform();
          }
        }, { passive: false });

        stage.addEventListener('touchend', function (event) {
          if (event.touches.length < 2) {
            zoomStartDistance = 0;
            zoomStartScale = zoomScale;
          }
          if (!event.touches.length) {
            if (zoomSwipeStart && event.changedTouches && event.changedTouches.length && zoomScale === 1) {
              var deltaX = event.changedTouches[0].clientX - zoomSwipeStart.x;
              var deltaY = event.changedTouches[0].clientY - zoomSwipeStart.y;
              if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) {
                setZoomImage(zoomIndex + (deltaX < 0 ? 1 : -1));
              }
            }
            zoomDragStart = null;
            zoomSwipeStart = null;
          }
        }, { passive: true });
      }

      function ensureZoomModal() {
        if (zoomModal) return;

        zoomModal = document.createElement('div');
        zoomModal.className = 'dt-pdp-ab-zoom';
        zoomModal.hidden = true;
        zoomModal.setAttribute('role', 'dialog');
        zoomModal.setAttribute('aria-modal', 'true');
        zoomModal.setAttribute('aria-label', 'Product image viewer');
        zoomModal.innerHTML = [
          '<button class="dt-pdp-ab-zoom__close" type="button" aria-label="Close product image viewer">&times;</button>',
          '<button class="dt-pdp-ab-zoom__nav dt-pdp-ab-zoom__nav--prev" type="button" aria-label="Previous product image">&lsaquo;</button>',
          '<button class="dt-pdp-ab-zoom__nav dt-pdp-ab-zoom__nav--next" type="button" aria-label="Next product image">&rsaquo;</button>',
          '<div class="dt-pdp-ab-zoom__stage" data-zoom-stage>',
          '<img class="dt-pdp-ab-zoom__image" alt="">',
          '</div>',
          '<div class="dt-pdp-ab-zoom__thumb-wrap">',
          '<button class="dt-pdp-ab-zoom__thumb-nav dt-pdp-ab-zoom__thumb-nav--prev" type="button" aria-label="Scroll previews left">&lsaquo;</button>',
          '<div class="dt-pdp-ab-zoom__thumbs" aria-label="Product image previews"></div>',
          '<button class="dt-pdp-ab-zoom__thumb-nav dt-pdp-ab-zoom__thumb-nav--next" type="button" aria-label="Scroll previews right">&rsaquo;</button>',
          '</div>'
        ].join('');

        document.body.appendChild(zoomModal);
        zoomCloseButton = zoomModal.querySelector('.dt-pdp-ab-zoom__close');
        zoomPreviousButton = zoomModal.querySelector('.dt-pdp-ab-zoom__nav--prev');
        zoomNextButton = zoomModal.querySelector('.dt-pdp-ab-zoom__nav--next');
        zoomThumbPreviousButton = zoomModal.querySelector('.dt-pdp-ab-zoom__thumb-nav--prev');
        zoomThumbNextButton = zoomModal.querySelector('.dt-pdp-ab-zoom__thumb-nav--next');
        zoomImage = zoomModal.querySelector('.dt-pdp-ab-zoom__image');
        zoomThumbs = zoomModal.querySelector('.dt-pdp-ab-zoom__thumbs');

        var stage = zoomModal.querySelector('[data-zoom-stage]');
        if (stage) bindZoomTouch(stage);
        if (zoomCloseButton) zoomCloseButton.addEventListener('click', closeZoomModal);
        if (zoomPreviousButton) zoomPreviousButton.addEventListener('click', function () { setZoomImage(zoomIndex - 1); });
        if (zoomNextButton) zoomNextButton.addEventListener('click', function () { setZoomImage(zoomIndex + 1); });
        if (zoomThumbPreviousButton) zoomThumbPreviousButton.addEventListener('click', function () { scrollZoomThumbs(-1); });
        if (zoomThumbNextButton) zoomThumbNextButton.addEventListener('click', function () { scrollZoomThumbs(1); });
        zoomModal.addEventListener('click', function (event) {
          if (event.target === zoomModal) closeZoomModal();
        });
      }

      function openZoomModal(index, trigger) {
        var items = zoomItems();
        if (!items.length) return;

        ensureZoomModal();
        zoomLastTrigger = trigger || null;
        zoomModal.hidden = false;
        document.documentElement.classList.add('dt-pdp-ab-zoom-open');
        setZoomImage(index);
        window.requestAnimationFrame(function () {
          zoomModal.classList.add('is-open');
          if (zoomCloseButton) zoomCloseButton.focus();
        });
      }

      showGallerySlide = function (index) {
        var enabledSlides = activeSlides();
        if (!enabledSlides.length) return;
        loadGallerySlide(enabledSlides[(index + enabledSlides.length) % enabledSlides.length]);
        updateGalleryState(index);

        if (useScrollGallery) {
          var targetSlide = enabledSlides[activeIndex];
          track.scrollTo({
            left: targetSlide ? targetSlide.offsetLeft : 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      };

      if (previous) previous.addEventListener('click', function () { showGallerySlide(activeIndex - 1); });
      if (next) next.addEventListener('click', function () { showGallerySlide(activeIndex + 1); });
      if (useScrollGallery) {
        track.addEventListener('scroll', function () {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(function () {
            updateGalleryState(currentScrollIndex());
            updateGalleryProgress();
            scrollFrame = null;
          });
        }, { passive: true });
        window.addEventListener('resize', updateGalleryProgress);
      }

      gallery.addEventListener('pointerdown', function (event) {
        var slide = event.target.closest('[data-slide]');
        if (!event.isPrimary || event.target !== primarySlideImage(slide)) return;
        var enabledSlides = activeSlides();
        var pointerIndex = enabledSlides.indexOf(slide);
        if (pointerIndex >= 0) {
          loadGallerySlide(enabledSlides[(pointerIndex + 1) % enabledSlides.length]);
          loadGallerySlide(enabledSlides[(pointerIndex - 1 + enabledSlides.length) % enabledSlides.length]);
        }
        galleryPointerStart = { x: event.clientX, y: event.clientY };
        galleryPointerMoved = false;
      }, { passive: true });

      gallery.addEventListener('pointermove', function (event) {
        if (!galleryPointerStart) return;
        var deltaX = Math.abs(event.clientX - galleryPointerStart.x);
        var deltaY = Math.abs(event.clientY - galleryPointerStart.y);
        if (deltaX > 8 || deltaY > 8) galleryPointerMoved = true;
      }, { passive: true });

      gallery.addEventListener('pointerup', function () {
        window.setTimeout(function () {
          galleryPointerStart = null;
          galleryPointerMoved = false;
        }, 0);
      }, { passive: true });

      gallery.addEventListener('click', function (event) {
        if (galleryPointerMoved) return;
        if (event.target.closest('button, a, input, select, textarea, label, [data-gallery-prev], [data-gallery-next]')) return;

        var slide = event.target.closest('[data-slide]');
        var image = primarySlideImage(slide);
        var enabledSlides = activeSlides();
        var clickedIndex = enabledSlides.indexOf(slide);

        if (!image || event.target !== image || clickedIndex === -1) return;
        openZoomModal(clickedIndex, image);
      });

      document.addEventListener('keydown', function (event) {
        if (!zoomModal || zoomModal.hidden) return;

        if (event.key === 'Escape') {
          closeZoomModal();
        } else if (event.key === 'ArrowLeft') {
          setZoomImage(zoomIndex - 1);
        } else if (event.key === 'ArrowRight') {
          setZoomImage(zoomIndex + 1);
        }
      });

      showGallerySlide(0);
    }

    updateVariant();
    var activePackCard = towelNeedCards.find(function (card) {
      return card.getAttribute('aria-pressed') === 'true';
    });
    if (activePackCard) applyPackCard(activePackCard);
  });
})();
